import React from 'react';
import classes from './Button.module.scss';
import Arrow from '@material-ui/icons/ArrowForwardOutlined';

const Button = ({ hover, className, children }) => {
  const classNames = [classes.Button];
  if (className) classNames.push(className);
  if (hover) classNames.push(classes.Hover);

  return (
    <button className={classNames.join(' ')}>
      <p className={classes.Text}>{children}</p>
      <Arrow className={classes.Arrow} />
      <div className={classes.Border}></div>
    </button>
  );
}

export default Button;
